import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ListDeliveredMedicationsResponse } from 'vidis-common/delivered-medication';
import { MandateService } from '../mandate/mandate.service';
import { MandatePermissions } from '../../models/enum/mandate-permissions.enum';
import { switchMap } from 'rxjs/operators';
import { CountResult } from 'vidis-common/common/models/count-result.model';

@Injectable({
  providedIn: 'root'
})
export class DeliveredMedicationsService {
  private readonly http = inject(HttpClient);
  private readonly mandateService = inject(MandateService);

  getDeliveredMedications(ssin: string): Observable<ListDeliveredMedicationsResponse> {
    return this.mandateService.hasAccess(MandatePermissions.consultDeliveredMedications).pipe(
      switchMap(hasAccess => {
        if (hasAccess) {
          return this.http.post<ListDeliveredMedicationsResponse>('/v2/deliveredMedications/findAll', { ssin });
        } else {
          return throwError(() => ({errors: [{code: 'no-access'}]}));
        }
      }
      ));
  }

  countDeliveredMedications(
    ssin?: string
  ): Observable<CountResult> {
    return this.mandateService.hasAccess(MandatePermissions.consultDeliveredMedications).pipe(
      switchMap(hasAccess => {
        if (hasAccess) {
          return this.http.post<CountResult>('/v2/deliveredMedications/count', { ssin });
        } else {
          return throwError(() => ({errors: [{code: 'no-access'}]}));
        }
      })
    );
  }
}
